<div class="flex info-group-component">
  <span class="info info-start">{{ firstValue() }}</span>
  <span
    class="info info-end cursor-pointer"
    (click)="viewDetails.emit()"
    (keydown.enter)="viewDetails.emit()"
    [pTooltip]="tooltipTemplate() ?? ''"
    tooltipPosition="bottom"
    [autoHide]="false"
    >{{ secondValue() }}</span
  >
</div>
